@switch (type()) {
  @case (typer.moete) {
    <tips>
      {{'Følgende informasjon er ikke synlig for medlemmer uten tilgang til møte:'|translate}}
      <ul>
        <li>{{'Formål'|translate}}</li>
        <li>{{'Saker, inkludert dokumenter og annet som er tilknyttet sakene'|translate}}</li>
      </ul>
      {{'Merk at medlemmer uten tilgang til møte ikke kan settes til å signere protokoll eller avgi stemme på avstemninger.'|translate}}
    </tips>
  }
  @case (typer.sak) {
    <tips>
      {{'Følgende informasjon er ikke synlig for medlemmer uten tilgang til sak:'|translate}}
      <ul>
        <li>{{'Saken, inkludert dokumenter og annet som er tilknyttet denne'|translate}}</li>
      </ul>
      {{'Merk at medlemmer uten tilgang til sak ikke kan settes til å signere protokoll eller avgi stemme på avstemninger.'|translate}}
    </tips>
  }
  @case (typer.arkivmappe) {
    <tips>
      {{'Følgende informasjon er ikke synlig for medlemmer uten tilgang til biblioteksmappe:'|translate}}
      <ul>
        <li>{{'Underliggende mapper'|translate}}</li>
        <li>{{'Underliggende dokumenter'|translate}}</li>
      </ul>
    </tips>
  }
}
